import React, { useEffect, useState } from "react";
import { getAuTomationDoc, getUploadedDocumentsApi, mapAutomationDocApi, searchDocName } from "../../../CommunityActionCreator";
// import { PDFReader } from 'reactjs-pdf-reader'
import { getExtensionAndUrlPrefixFromName } from '../../../../CommonUtils'
import { useLocation } from "react-router-dom";
import Loader from "../../../../../../../presentationals/Loader/Loader.component";
import AddDocumentInfo from './AddDocumentInfo'
import { Tooltip } from "@mui/material";
import MapDoc from "./MapAutomationDocPopup";
import PDFViewer from '../../../../CommonComponents/PdfViewr'
import zipimage from '../../../Images/zipimage.png'
import fileBroken from '../../../Images/fileBroken.png'

const Documents = ({ rowData }) => {
    const [documentList, setDocumentList] = useState([])
    const [loaderState, setloaderState] = useState(false)
    const [viewType, setViewType] = useState("")

    const location = useLocation();
    const [automationDocs, setautomationDocs] = useState([])
    const [mapDocPopup, setmapDocPopup] = useState(false)
    const [mapData, setmapData] = useState({})
    const [matchingData, setMatchingData] = useState([])
    const [matchingDiv, setMatchingDataDiv] = useState(false)
    const [msg, setMessage] = useState('')

    useEffect(() => {
        if (rowData) {
            getDocumentDetailByUserId(rowData.userId)
            // if (window.location.href.includes('/admin')) {
                automationDocument(rowData.userId)
            // }
        }
    }, [])
    const close = () => {
        setmapDocPopup(false)
    }
    const getDocumentDetailByUserId = (userId) => {
        setloaderState(true)
        getUploadedDocumentsApi(userId, callBack => {
            setDocumentList(callBack)
            setloaderState(false)
        })
    }
    const editHandler = (type) => {
        setViewType(type)
        if (type === "save") {
            getDocumentDetailByUserId(rowData.userId)
        }
    }
    const automationDocument = (userId) => {
        setloaderState(true)
        getAuTomationDoc(userId, callBack => {
            setautomationDocs(callBack.data)
            setloaderState(false)
        })
    }
    const mapAutomationDoc = (data) => {
        console.log(data)
        let changeData = { ...mapData }
        changeData.docName = data.docName
        changeData.url = data.url
        changeData.type = data.type
        setmapData(changeData)
        // changeData 'url': changeData.url,
        // 'type': changeData.type,
        // 'docName': changeData.docName,

        setmapDocPopup(true)
    }
    const submitMap = () => {
        console.log(mapData)
        if (mapData.description) {
            mapAutomationDocApi(rowData, mapData, callBack => {
                console.log(callBack)
                if (callBack.message === 'success') {
                    getDocumentDetailByUserId(rowData.userId)
                    setmapDocPopup(false)

                }
            })
        }
    }

    const mapchangehandler = () => {

    }
    const docNameHandler = (data) => {
        // console.log(data, 'data')
        let changeObjectData = { ...mapData }
        changeObjectData['docName'] = data.doc_name
        changeObjectData['documentId'] = data.document_id

        setmapData(changeObjectData)
        setMatchingDataDiv('')

    }
    const descriptionHandler = (e, type) => {
        let changeObjectData = { ...mapData }
        if (type === 'description') {
            changeObjectData['description'] = e
        }
        if (type === 'docName') {
            changeObjectData['docName'] = e
            console.log(e, 'gfcvbnjhgf')
            if (e) {
                searchDocName(e, callBack => {
                    setMatchingData(callBack.data)
                    if (callBack.data) {
                        setMatchingDataDiv(true)
                    }
                })
            } else {
                setMatchingDataDiv(false)

            }

        }
        setmapData(changeObjectData)

    }
    return (
        <div>
            <div className=''>

                <div className='col-sm-12 col-xs-12'>
                    <div className="profile-details-box-new" style={{ marginLeft: '-6px', overflow: "hidden" }}>
                        <div className="new-basic-head" > Document Details
                            {/* <Tooltip title="Add or Edit Documents"  onClick={e => editHandler('edit')}>Nth */}
                            {/* <button style={{ float: "right" }} onClick={e => editHandler('edit')}>
                                    <i className='fa fa-edit' style={{ color: "white" }} />
                                </button> */}
                            {/* </Tooltip> */}
                            {
                                !window.location.href.includes("/external") ? <Tooltip title="Add or Edit Documents" >
                                    <i className='fa fa-edit mt-1' style={{ float: 'right' }} onClick={e => editHandler('edit')}></i>
                                </Tooltip> : ""
                            }
                        </div>
                        {/* { documentList && documentList.length > 0 ? */}
                        {
                            viewType === "edit" ?
                                <div>
                                    <AddDocumentInfo rowData={rowData}></AddDocumentInfo>
                                    <div className='mt-3 row' style={{ marginTop: '50px' }}>
                                        <div className="col-12 text-center" style={{ marginBottom: '10px' }}>
                                            <button className="cred-btn" onClick={e => editHandler('save')}>Save</button>
                                        </div>
                                    </div>
                                </div>
                                : <div style={{ padding: '10px' }}>
                                    <div className='row'>
                                        {documentList && documentList.length > 0 ?
                                            documentList.map((data, i) => {
                                                console.log(data)
                                                if (data.documentUrl) {
                                                    const fileExtensionAndPrefix = getExtensionAndUrlPrefixFromName(data.documentUrl)
                                                    const fileExtension = fileExtensionAndPrefix.extension
                                                    const url = fileExtensionAndPrefix.urlPrefix + fileExtension + ";base64," + encodeURI(data.documentUrl)
                                                    return (
                                                        <div className='col-sm-4 col-xs-12 document-pdf text-center' key={i}>
                                                            {
                                                                fileExtension.includes('zip') ?
                                                                    <div className='document-box'>
                                                                        <h6 className='text-center' ><b>{data.documentName + '.zip'}</b></h6>
                                                                        <Tooltip title="Click to Download!">
                                                                            <a href={data.documentUrl} target='_blank'> <img src={zipimage} alt="" width='100%' /></a></Tooltip>
                                                                        {/* <div className='text-center'>
                                                                            <a target='_blank' className='cred-btn mt-5 noDecoration' >Download</a>
                                                                        </div> */}
                                                                    </div>
                                                                    :
                                                                    <div className='document-box'>
                                                                        <a href={data.documentUrl} target='_blank'>  <h6 className='text-center' ><b>{data.documentName}</b></h6></a>
                                                                        {
                                                                            data.documentUrl.includes('pdf') ?
                                                                                // <PDFReader url={url} showAllPage={true} />
                                                                                <PDFViewer url={url} /> 
                                                                                : data.documentUrl.includes('png') || data.documentUrl.includes('jpg') || data.documentUrl.includes('jpeg')
                                                                                    ? <img src={url} alt="" width='100%' /> :
                                                                                    <div>
                                                                                        <Tooltip title="Click to Download!">
                                                                                            <a href={data.documentUrl} target='_blank'> 
                                                                                            <img src={fileBroken} alt="" width='100%' /></a></Tooltip>
                                                                                        <div className='text-center'>
                                                                                        </div>
                                                                                    </div>
                                                                        }
                                                                    </div>
                                                            }
                                                            <br />
                                                        </div>
                                                    )
                                                }

                                            })
                                            : <div className="" style={{paddingLeft:'15px'}}><h4>No Documents Uploaded!</h4></div>
                                        }
                                    </div>
                                </div>
                            /* : <div className="ml-2"><h4>No Documents Uploaded!</h4></div> */
                        }
                    </div>
                </div>
                {/* {window.location.href.includes('/admin') ? */}
                    <div className='col-sm-12 col-xs-12'>
                        <div className="profile-details-box-new" style={{ marginLeft: '-6px', overflow: "hidden" }}>
                            <div style={{ padding: '10px' }}>
                                <div className="new-basic-head" >Automation Documents</div>
                                <div className='row'>
                                    {automationDocs && automationDocs.length > 0 ?
                                        automationDocs.map((data, i) => {
                                            if (data.url) {
                                                const fileExtensionAndPrefix = getExtensionAndUrlPrefixFromName(data.url)
                                                const fileExtension = fileExtensionAndPrefix.extension
                                                // const url = fileExtensionAndPrefix.urlPrefix + fileExtension + ";base64," + encodeURI(data.documentInString)
                                                return (
                                                    <div className='col-sm-4 col-xs-12 document-pdf text-center' key={i} >
                                                        <div className='document-box'>
                                                            <div className="text-center mb-2" >
                                                                <button className="cred-btn" onClick={() => mapAutomationDoc(data)} >Map Document</button>
                                                            </div>
                                                            <a href={data.url} target='_blank'>  <h6 className='text-center' ><b>{'Download'}</b></h6></a>
                                                                {data.url.includes('pdf') ?
                                                                 <PDFViewer url={url} /> 
                                                                    // <PDFReader url={data.url} showAllPage={true} />
                                                                    : <img src={data.url} alt="" width='100%' />}

                                                        </div>
                                                        <br />
                                                    </div>
                                                )
                                            }

                                        })
                                        : <div className="" style={{paddingLeft:'15px'}}><h4>No Documents Uploaded!</h4></div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* : ""} */}
            </div>
            {loaderState ?
                <Loader />
                : ""}
            {mapDocPopup ?
                <MapDoc
                    descriptionHandler={descriptionHandler}
                    docNameHandler={docNameHandler}
                    matchingData={matchingData}
                    matchingDiv={matchingDiv}
                    mapData={mapData} close={close} submitMap={submitMap} />
                : ""}
        </div>
    )
}
export default Documents